import React, { ReactNode, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import HeaderComp from '../Respond/HeaderComp';
import SideMenu from '../Respond/Sidemenu';
import { QcastSidebar } from './QcastSidebar';
import { useBoundStore } from 'src/store';
import { useNavigate } from 'react-router-dom';
import ProgressBar from 'src/components/ProgressBar';
import MultipleVideoPlayer from 'src/components/MultipleVideoPlayer';
import ReactPlayer from 'react-player';
import { generateVideoThumbnail, getTotalVideoDuration } from 'src/shared/utils/helper';
import NavigationController from '../Play/NavigationController';
import { IoPerson } from 'react-icons/io5';
import VideoPlayer from 'src/components/VideoPlayer';
import { theme } from 'src/styles/theme';
import { useMediaQuery } from 'react-responsive';
import CircularProgress from 'src/components/CircularProgress';

// Define the props interface for our component
interface IndexedVideo {
  index: number;
  video: any;
  duration?: number;
  transcriptionText?: string;
}
interface ReviewQcastStudioProps {
  questions: any[];
  videos: IndexedVideo[];
  qcast: any;
  transcriptions: any[];
  thumbnails: string;
  onPublish: (qcastDetails: any) => Promise<boolean>;
}

// Styled Components
const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: space-between;
    color: #000;
    background: #FFF;
`;

const ContentArea = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
`;

const LeftContainer = styled.div<{ snapshot?: string }>`
  width: calc(100vw - 480px);
  height: 100%
  display: flex; 
  flex-direction: column;
  // gap: 24px;

  color: white;
  display: flex;
  flex-direction: column;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  border-top-right-radius: 20px;
  color: white;
  background: #E9E7E9;
  background-image: ${({ snapshot }) => `url(${snapshot})`};
  background-size: cover;
  background-position: center;
  position: relative;

  &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.1); /* Transparent overlay */
      backdrop-filter: blur(15px); /* Glass effect */
      -webkit-backdrop-filter: blur(15px);
      border-radius: 10px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }

  @media(max-width: ${theme.breakpoints.tabletAir}px) {
    width: 100%;
    height: 100%;
  }
`;

const RightPanel = styled.div`
  width: 480px;
  // height: 100vh;


  @media(max-width: ${theme.breakpoints.tabletAir}px) {
    display: none;
  }
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  flex: 1;
`;

const VideoArea = styled.div`
    width: 100%;
    height: auto;

    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: space-between;
    padding: 0px 40px;

    z-index: 999999999;

    @media(max-width: ${theme.breakpoints.mobile}px) {
      padding-top: 40px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
`;

const VideoContainer = styled.div`
    width: 100%;
    height: auto;
    gap: 40px;
    border-radius: 320px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;;

const PlayerHost = styled.div<{ size?: string }>`
  width: ${props => props.size || '520px'};
  height: ${props => props.size || '520px'};
`;

const UserProfileAvatar = styled.div<{ ismobile?: boolean }>`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-bottom: 40px;
  box-shadow: 0px 30px 100px -20px #00000033;
  background: #39393A;  
  position:relative;
  left: ${props => props.ismobile ? '160px' : '235px'};
  bottom: 140px;
  z-index: 99999999999999999999;
  clip-path: circle(50% at center); 

  &>svg{
    width: 100%;
    height: 100%;
    margin-top: 20px;
  }

  @media(max-width: ${theme.breakpoints.mobile}px) {
    left: 190px;
  }
`;

// Main component
const ReviewQCastStudio: React.FC<ReviewQcastStudioProps> = ({
  questions,
  videos,
  qcast,
  transcriptions,
  thumbnails,
  onPublish
}) => {

  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [progress, setProgress] = useState<number>(0);
  const [progress2, setProgress2] = useState<number>(0);
  const [totalProgress, setTotalProgress] = useState<number>(0);
  const [totalProgress2, setTotalProgress2] = useState<number>(0);
  const [controllerPlay, setControllerPlay] = useState<boolean>(false);
  const [allquestions, setAllquestions] = useState<any[]>(questions);
  const [totalPlayedDuration, setTotalPlayedDuration] = useState<number>(0);
  const [totalDuration, setTotalDuration] = useState<number>(0);
  const [playing, setPlaying] = useState(false);
  const [playing2, setPlaying2] = useState(false);
  const [activeVideo, setActiveVideo] = useState<"main" | "multi" | null>(null);

  const [muteVideo, setMuteVideo] = useState(false);
  const [multiVideos, setMultiVideos] = useState<any[]>([]);
  const [repeatPlayback, setRepeatPlayback] = useState<boolean>(false);
  const [thumbnail, setThumbnail] = useState<string>("");


  const [title, setTitle] = useState<string>("Testing the new Qcast Plugin design");
  const [tags, setTags] = useState<string[]>([]);

  const [videoList, setVideoList] = useState<any[]>([])

  const [tempPlayers, setTempPlayers] = useState<ReactNode[]>([]);

  const [pause, setPause] = useState<"PLAYED" | "PLAYING" | "TOPLAY">("TOPLAY");
  const [seeking, setSeeking] = useState<boolean>(false);

  const isMobileScreen = useMediaQuery({ query: `(max-width: 460px)` })


  const navigate = useNavigate();

  const handleChangeQcast = (index: number) => {
    setActiveVideo("main")
    if (index === -1 && currentIndex === 0) return;
    if (index === 1 && currentIndex === videos.length - 1) return;
    handleNextVideo(currentIndex + index)
   // setCurrentIndex((prev) => prev + index);
  }
  const handleSelectVideo = (index: number) => {
    setCurrentIndex(index);
  };

  const handleAction = async () => {
    console.log("qcast.listOfVideos",qcast.listOfVideos)
    const qcastDetails = {
      video: videos,
      title: qcast?.title,
      tag: tags.join("|"),
      userId: qcast?.userId,
      qcastId: qcast.qcastId,
      questionList: qcast.listOfVideos.map(url => url.split('/').pop()),
      answerIndex: videos.map((video) => video.index),
      thumbnails: thumbnails || thumbnail,
      transcriptions: transcriptions,
      askSignUp: false,
      isPlugin: true
    };
    console.log(qcastDetails)
    
    const result = await onPublish(qcastDetails);
    
    if (result) {
      navigate("/publish")
    }

  }

  const handleVideoEnded = () => {
    setActiveVideo("main")
    if (currentIndex === videos.length - 1) {
      return;
    }
    setCurrentIndex((prev) => prev + 1);
  }

  const handlePlay = (status: boolean) => {
    setControllerPlay(status)
    if (activeVideo == "main") {
      setPlaying(status)
      return
    }
    if (activeVideo == "multi") {
      setPlaying2(status)
      return
    }
    setActiveVideo("main")
    setPlaying(status)

  }

  const handleProgress = (prog: number) => {
    setProgress(prog);
  }

  const handleNextVideo = (index: number) => {
    setCurrentIndex(index);
    setActiveVideo("main")
    setPlaying(true)

  }
  const handleRepeatPlayback = (value: boolean) => {
    setRepeatPlayback(value);
  }

  const handleMuteVideo = (status: boolean) => {
    setMuteVideo(status);
  }

  const handleThumbnail = async () => {
    if (videos.length === 0) return;
    if (thumbnails !== "") return;
    const thumb: any = await generateVideoThumbnail(videos[0].video, 2, 0.8);
    setThumbnail(thumb);
  }

  useEffect(() => {
    const total = videos.reduce((sum, video) => sum + video?.duration, 0);
    const totalQuestion = allquestions.reduce((sum, video) => sum + video?.questionDuration, 0);
    setTotalDuration(total+totalQuestion);
  }, [videos,allquestions]);
  useEffect(() => {
    const prog2 = progress2 / (100 / allquestions[currentIndex]?.questionDuration || 0.01)
    const vidDur = videos[currentIndex]?.duration || 0.01
    const quesDur = allquestions[currentIndex]?.questionDuration || 0.01
    const factor = 100 / (vidDur + quesDur)
    let ownProgress=progress
    if(activeVideo=="main"&&(playing || playing2)){
      ownProgress=0
    }
    setTotalProgress((prog2 + ownProgress) * factor)
    setTotalProgress2((prog2 + ownProgress))
  }, [progress, progress2]);

  useEffect(() => {
    if (videos.length > 0) {
     setMultiVideos(
  videos.flatMap((video, index) =>
    video.video instanceof Blob
      ? [{
          url: window.URL.createObjectURL(video.video),
          title: "",
          index: index
        }]
      : []
  )
);
    }
  }, [videos]);


  useEffect(() => {
    if (videos.length > 0) {
      console.log("setVideoList",videos,allquestions)
      setVideoList(
        videos.map((video, index) => {
          const duration=(allquestions[index]?.questionDuration || 0.01) + video?.duration||0
          return{
          ...video,
          index: index + 1,
          answerIndex:video.index,
          status: "TOPLAY",
          progress: 0,
          duration:duration
        }})
      );
      handleThumbnail();
    }
  }, [videos,allquestions]);
  const updateDuration = (duration: number, index: number) => {
    const previousList = [...allquestions]

    previousList[index]["questionDuration"] = duration
    setAllquestions(
      previousList
    );
  }


  useEffect(() => {
    if (videoList.length === 0) return;
    let updatedVideos = videoList.map((video, index) => ({
      ...video,
      status: index === currentIndex
        ? "PLAYING"
        : index < currentIndex
          ? "PLAYED"
          : "TOPLAY"
    }));

    if ((playing||playing2) && totalProgress2 > 0) {
      updatedVideos = updatedVideos.map((video, index) =>
        index === currentIndex ? { ...video, progress:totalProgress2 } : video
      );
    }

    setVideoList(updatedVideos);
  }, [playing, totalProgress2, currentIndex]);
  useEffect(() => {
    if (questions) {
      setAllquestions([...questions])
    }

  }, [questions]);
const onVideoCompleted=()=>{
  /* const allVideo=[...videoList]
  allVideo[videoList.length-1]["status"]="PLAYED"
  allVideo[videoList.length-1]["progress"]=0
  setVideoList(allVideo) */
  setControllerPlay(false)
  setActiveVideo("main")
  setPlaying2(false)
  setPlaying(false)
}
console.log("multiVideos",multiVideos)
console.log("allquestions",allquestions)

  return (
    <Container>
      <LeftContainer>
        <HeaderComp onCancel={() => { }} onAction={handleAction} type="review" color={"#000000"} />
        <VideoArea >
          <SideMenu activeMenuItem="Review" color={"#000000"} float={true} />
          <Content style={{ width: "100%", padding: "0px 40px" }}>
            <PlayerHost size={isMobileScreen ? `280px` : `320px`}>
              <CircularProgress
                size={270}
                strokeWidth={7}
                progress={totalProgress}
                progressColor="#8451D6"
                trailColor="#ddd"
                startAngle={270}
                onFinish={() => alert("Progress Completed!")}
              >
                <MultipleVideoPlayer
                  videos={multiVideos}
                  overidePlay={true}
                  currentIndex={currentIndex}
                  size={"320px"}
                  playing={activeVideo == "multi" && playing2}
                  muteVideo={muteVideo}
                  onVideoEnded={handleVideoEnded}
                  onVideoCompleted={()=>{onVideoCompleted()}}
                  onProgress={handleProgress}
                  onDuration={() => { }}
                  onPause={handlePlay}
                  onSeek={() => { }}
                  onNextVideo={handleNextVideo}
                  repeatVideoPlayback={false}
                />
              </CircularProgress>

              <UserProfileAvatar ismobile={isMobileScreen}>
                <VideoPlayer
                  vidSrc={allquestions[videoList[currentIndex]?.answerIndex||0]?.url || ""}
                  hidePlayVideoIcon={true}
                  play={activeVideo == "main" && playing}
                  showProgress={false}
                  size={120}
                  playsize={48}
                  hideSeek={true}
                  onProgress={(e) => { setProgress2(e) }}
                  onDuration={(e) => { updateDuration(e, currentIndex) }}
                  onPause={() => { }}
                  onPlay={() => { }}
                  onReady={(e) => {  }}
                  onVideoEnded={() => { setActiveVideo("multi");setPlaying2(true) }}
                />
              </UserProfileAvatar>
            </PlayerHost>

            <NavigationController hideResponse={true} onNavigate={handleChangeQcast} onResponse={() => { }} />
          </Content>

        </VideoArea>

        <div style={{ width: "100%", padding: "0px 40px", zIndex: "999999999999999999" }}>
          <ProgressBar
            currentIndex={currentIndex}
            videos={videoList}
            progress={totalProgress}
            totalDuration={totalDuration}
            onPlay={handlePlay}
            playing={controllerPlay}
            onRepeat={() => { }}
            onSelectVideo={handleSelectVideo}
            onMute={handleMuteVideo}
            onShuffle={() => { }}
            hideDuration={true}
            hideRepeat={true}
            hideShuffle={true}
            hideQueueBtn={true}
            barColor='#B7AAD6'
          />
        </div>
      </LeftContainer>
      <RightPanel>
        <QcastSidebar totalQstn={questions.length} transcriptions={transcriptions} totalResponse={videos.length} videos={videos} currentIndex={currentIndex} />
      </RightPanel>
      {tempPlayers}
    </Container>
  );
};

export default ReviewQCastStudio;


